import {AutocompleteInput, BooleanField, Button, CreateButton, Datagrid, FunctionField, List, SelectInput, TextField, TextInput, TopToolbar, useRedirect} from "react-admin";
import {Chip} from "@material-ui/core";
import {Assessment} from "@material-ui/icons";
import React, {useEffect, useMemo, useState} from "react";
import {
  useQuizAssessmentQuestionBankDataProvider
} from "../../providers/data-provider/quiz-assessment-question-bank.data-provider";
import {
  useQuizAssessmentAvailabilityDataProvider
} from "../../providers/data-provider/quiz-assessment-availability.data.provider";
import {brazilianDateFormat} from "../../utils/date-formatter.util";


export function QuizAssessmentAvailabilityList(props) {
  const [banks, setBanks] = useState([]);
  const [classes, setClasses] = useState([]);
  const [academicPeriods, setAcademicPeriods] = useState([]);
  const { listBanks } = useQuizAssessmentQuestionBankDataProvider();
  const { listClassesRelated, listAcademicPeriodsRelated } = useQuizAssessmentAvailabilityDataProvider()

  useEffect(() => {
    listBanks().then(res => setBanks(res.data.data));
  }, [listBanks]);

  useEffect(() => {
    listClassesRelated().then(res => setClasses(res.data.data));
  }, [listClassesRelated]);

  useEffect(() => {
    listAcademicPeriodsRelated().then(res => setAcademicPeriods(res.data.data));
  }, [listAcademicPeriodsRelated]);


  const filters = [
    <TextInput
      source="availabilityName"
      label={'Avaliação'}
      alwaysOn
    />,

    <AutocompleteInput
      source="bankId"
      emptyText="Todos"
      clearAlwaysVisible={true}
      fullWidth
      label={'Banco de Questões'}
      choices={banks}
      alwaysOn
      allowNull
    />,

    <SelectInput
        label="Período Letivo"
        source="academicPeriodId"
        emptyValue={""}
        choices={academicPeriods}
        alwaysOn
    />,

    <AutocompleteInput
      source="classId"
      emptyText="Todos"
      clearAlwaysVisible={true}
      fullWidth
      label={'Turma'}
      choices={classes}
      alwaysOn
      allowNull
    />,
    <SelectInput
        label="Desabilitados"
        source="disabled"
        emptyValue={""}
        choices={[
          { name: "Desabilitados", id: "disabled" },
          { name: "Todos", id: "" },
        ]}
        alwaysOn
    />,
  ];

  const ListActions = () => (
    <TopToolbar>
      <CreateButton label="NOVA AVALIAÇÃO" />
    </TopToolbar>
  );

  return (
    <>
      <List
        filters={filters}
        exporter={false}
        bulkActionButtons={false}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid rowClick={'edit'}>
          <FunctionField
            label={'Turmas'}
            source={'classes'}
            render={record => <ClassesField record={record} />}
          />
          <TextField source={'name'} label={'Nome da Avaliação'} />
          <TextField source={'question_bank.name'} label={'Banco de Questões'} />
          <TextField source={'questionAmount'} label={'Quantidade de Questões'} />
          <FunctionField
            label={'Tipo de Avaliação'}
            source={'assessmentType'}
            render={record => record.assessmentType === 'printed' ? 'Impressa' : 'Online'}
          />
          <FunctionField render={record => <DateField record={record} /> } label={'Disponibilidade'} />
          <FunctionField render={record => <StatusField record={record} /> } label={'Status'} />
          <FunctionField render={record => <ResultsButton record={record} />} />
        </Datagrid>
      </List>
    </>
  )
}

const DateField = ({ record }) => {
  const {
    start, end
  } = record;

  if (!start || !end) {
    return (
        <div style={{display: 'flex', gap: 10}}>
          -
        </div>
    )
  }

  return (
      <div style={{display: 'flex', gap: 10}}>
        {brazilianDateFormat(start)} - {brazilianDateFormat(end)}
      </div>
  )
}
const StatusField = ({ record }) => {
  const {
    start, end, assessmentType
  } = record;

  const color = useMemo(() => {
    if (assessmentType === 'printed') return 'red';

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const _start = new Date(start.substring(0,10) + 'T03:00:00Z');
    const _end = new Date(end.substring(0,10) + 'T03:00:00Z');

    if (today >= _start && today <= _end) return 'primary';
    if (today > _end) return 'secondary';
    return 'default'
  }, [start, end, assessmentType]);

  const label = useMemo(() => {
    if (assessmentType === 'printed') return 'Disponível';
    switch (color) {
      case 'primary': return 'Vigente';
      case 'secondary': return 'Encerrado';
      default: return 'Programado';
    }
  }, [color, start, end])

  if (record.disabled) {
    return (
        <div style={{display: 'flex', gap: 10}}>
          <Chip size={'small'} color={'default'} label={'Bloqueado'} />
        </div>
    )
  }
  return (
      <div style={{display: 'flex', gap: 10}}>
        <Chip size={'small'} color={color} label={label} />
      </div>
  )
}

const ResultsButton = ({ record }) => {
  const redirect = useRedirect();

  return (
    <Button
      label={'Resultados'}
      onClick={(event) => {
        event.stopPropagation();
        redirect(`/quiz-assessment-availability/results/${record.id}`);
      }}
    >
      <Assessment />
    </Button>
  )
}

const ClassesField = ({ record, field }) => {
  return (
    <>
      {record.classes.map(item => (
        <Chip key={item.id} label={item.name} />
      ))}
    </>
  )
}